import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-screenshot-large.tsx
/**
* icon.24.screenshot.large
*
* Keywords: camera, shutter, photography, aperture, circular, spiral, segments, capture
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDNhOSA5IDAgMSAxIDAgMTggOSA5IDAgMCAxIDAtMThNNi4zNzEgMTUuNzVsLS42NzcgMS4xN0E3Ljk4IDcuOTggMCAwIDAgMTIgMjB2LS4wMDFsLS40MzMtLjc0OS0yLjAyMS0zLjVMNy45NTggMTN6bTQuNDc0LjI1IDEuNTg4IDIuNzUuNjc2IDEuMTcyQTggOCAwIDAgMCAxOC45MjcgMTZ6TTQuNTg0IDlBOCA4IDAgMCAwIDQgMTJhNy45NiA3Ljk2IDAgMCAwIDEuMDcyIDMuOTk5bC40MzMtLjc0OSAyLjAyLTMuNUw5LjExMyA5em0xMy45MTEtLjI1LTIuMDIgMy41TDE0Ljg4NyAxNWg0LjUyOUE4IDggMCAwIDAgMjAgMTJhNy45NiA3Ljk2IDAgMCAwLTEuMDczLTMuOTk5ek04LjUzNSAxMmwxLjczMyAzaDMuNDY0bDEuNzMyLTMtMS43MzItM2gtMy40NjR6bTMuODk4LTcuMjUgMi4wMjEgMy41IDEuNTg3IDIuNzQ5IDEuNTg4LTIuNzQ5LjY3Ni0xLjE3MkE3Ljk4IDcuOTggMCAwIDAgMTIgNHptLTEuNTQzLS42NzNBOCA4IDAgMCAwIDUuMDczIDhoOC4wODJsLTEuNTg4LTIuNzV6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=13204-45234
*/
const Icon24ScreenshotLarge = memo(function Icon24ScreenshotLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18M6.371 15.75l-.677 1.17A7.98 7.98 0 0 0 12 20v-.001l-.433-.749-2.021-3.5L7.958 13zm4.474.25 1.588 2.75.676 1.172A8 8 0 0 0 18.927 16zM4.584 9A8 8 0 0 0 4 12a7.96 7.96 0 0 0 1.072 3.999l.433-.749 2.02-3.5L9.113 9zm13.911-.25-2.02 3.5L14.887 15h4.529A8 8 0 0 0 20 12a7.96 7.96 0 0 0-1.073-3.999zM8.535 12l1.733 3h3.464l1.732-3-1.732-3h-3.464zm3.898-7.25 2.021 3.5 1.587 2.749 1.588-2.749.676-1.172A7.98 7.98 0 0 0 12 4zm-1.543-.673A8 8 0 0 0 5.073 8h8.082l-1.588-2.75z"
		})
	});
});
//#endregion
export { Icon24ScreenshotLarge };

//# sourceMappingURL=icon-24-screenshot-large.js.map